export default __webpack_public_path__ + "static/media/SWT1880.34I-40412_-23927_0.dc27b6c6.jpg";